import type * as React from 'react'

import { cn } from '@/shared/helpers/styles.helper'

type Props = Omit<React.ComponentProps<'div'>, 'children'> & {
  count: number
  // Position of the current step, from 0
  current: number
  // Name of the progress bar, and text of the current step read by screen readers
  label: string
  valueText: string
}

// Colour of a segment: filled before the current step, lighter for the current step, pale after it
const segmentClass = (index: number, current: number) => {
  if (index < current) return 'bg-primary'
  if (index === current) return 'bg-[var(--blue-200)]'
  return 'bg-blue-100'
}

// Progress bar of the steps of a funnel, one segment per step, shown instead of the breadcrumb on mobile
export function StepsProgress({
  count,
  current,
  label,
  valueText,
  className,
  ...props
}: Props) {
  return (
    <div
      role='progressbar'
      aria-label={label}
      aria-valuemin={1}
      aria-valuemax={count}
      aria-valuenow={current + 1}
      aria-valuetext={valueText}
      className={cn('flex h-1.5 w-full bg-blue-100', className)}
      {...props}
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className={cn('h-full flex-1', segmentClass(index, current))}
        />
      ))}
    </div>
  )
}
